import { QuizConfig } from './types'
import { GUEST_PASS_EXIT_PATH } from '../components/constants'
import e10 from './e10.config'

const guestPass: QuizConfig = {
  ...e10,
  exitPath: GUEST_PASS_EXIT_PATH,
  screens: e10.screens.map((screen) => ({ ...screen, path: screen.path.replace(/^\/e10\//, '/guest-pass/') })),
}

export default guestPass
